import {defaultSinistreFormValue} from '.';
import {
  FamilleSinistreDTO,
  IError,
} from '../../types/interface/Sinistres/famille';

export const TitleLabels = {
  infos: {
    numeroContrat: 'Numéro de contrat',
    nomDeclarant: 'Nom du déclarant',
    nomContractant: 'Nom du contractant',
    telephone: 'N° téléphone',
    dateSinistre: 'Date du sinistre',
    lieuSinistre: 'Lieu du sinistre',
    agence: 'Agence ARO gestionnaire du contrat',
    circonstanceAccident: "Circonstances et causes de l'accident",
    photo: "Photo de l'accident",
    pieceJointeAgence: "Pièces à fournir à joindre ou à déposer à l'agence",
    estimationPrejudice: 'Estimations des préjudices',
  },
};

export const showErrorValuesDefault = {
  numeroContrat: false,
  nomDeclarant: false,
  nomContractant: false,
  telephone: false,
  dateSinistre: false,
  lieuSinistre: false,
  agence: false,
  circonstanceAccident: false,
  photo: false,
  pieceJointeAgence: false,
  estimationPrejudice: false,
};

export const showErrorValuesSubmit = {
  numeroContrat: true,
  nomDeclarant: true,
  nomContractant: true,
  telephone: true,
  dateSinistre: true,
  lieuSinistre: true,
  agence: true,
  circonstanceAccident: true,
  photo: true,
  pieceJointeAgence: true,
  estimationPrejudice: true,
};

export const defaultSinistreError: IError = {
  numeroContrat: '',
  nomDeclarant: '',
  nomContractant: '',
  telephone: '',
  dateSinistre: '',
  lieuSinistre: '',
  agence: '',
  circonstanceAccident: '',
  photo: '',
  pieceJointeAgence: '',
  estimationPrejudice: '',
};

export const defaultSinistreValue: FamilleSinistreDTO = {
  ...defaultSinistreFormValue,
};
